import React from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const MaleInfertilityInvestigationModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Male Infertility Investigation Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            {/* <div className='col-lg-6'> */}
            <div className="details">
              {/* <div className="table-title"MaleInfertilityInvestigationModal>
                Basic Information
              </div> */}
              <div className="details-table">
                <div>Patient ID</div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Male Details</div>
              <div className="details-table">
                <div>Blood Group</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_blood_group}
                </div>
                <div>HIV</div>
                <div>{activePatientJourneyModuleDetails?.hiv}</div>
                <div>HBsAg</div>
                <div>{activePatientJourneyModuleDetails?.hbsag}</div>
                <div>VDRL</div>
                <div>{activePatientJourneyModuleDetails?.vdrl}</div>
                <div>HCV</div>
                <div>{activePatientJourneyModuleDetails?.hcv}</div>
                <div>HB Electro Phoresis</div>
                <div>
                  {activePatientJourneyModuleDetails?.hb_electro_phoresis}
                </div>
                <div>Chromosome Analysis</div>
                <div>
                  {activePatientJourneyModuleDetails?.chromosome_analysis}
                </div>
                <div>Karyotyping</div>
                <div>{activePatientJourneyModuleDetails?.karyotyping}</div>
                <div>Y.Chromosome MicroDeletion</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.y_chromosome_microdeletion
                  }
                </div>
                <div>RBS (mg/dl)</div>
                <div>{activePatientJourneyModuleDetails?.rbs}</div>
                <div>PROL (mg/dl)</div>
                <div>{activePatientJourneyModuleDetails?.prol}</div>
                <div>HB1AC</div>
                <div>{activePatientJourneyModuleDetails?.hb1ac}</div>
                <div>FSH (mui/ml)</div>
                <div>{activePatientJourneyModuleDetails?.fsh}</div>
                <div>LH (miu/ml)</div>
                <div>{activePatientJourneyModuleDetails?.lh}</div>
                <div>E2 (pg/ml)</div>
                <div>{activePatientJourneyModuleDetails?.e2}</div>
                <div>Testosterone (ng/ml)</div>
                <div>{activePatientJourneyModuleDetails?.testosterone}</div>
                <div>No. of Pregnancies Achieved</div>
                <div>
                  {activePatientJourneyModuleDetails?.pregnancies_achieved}
                </div>
              </div>
            </div>

            {/*  </div>
      <div className='col-lg-6'>
           
          </div> */}
            <div className="details">
              <div className="table-title">Fertility Impairment Factor</div>
              <div className="details-table">
                <div>Fertility Impairment Factor</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.fertility_impairment_factor
                  }
                </div>
                <div>Fertility Impairment Factor Other</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.fertility_impairment_factor_other
                  }
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Illnesses / Harmful Influences</div>
              <div className="details-table">
                <div>Chronic illnesses</div>
                <div>
                  {activePatientJourneyModuleDetails?.chronics_illnesses}
                </div>
                <div>Working Environment</div>
                <div>
                  {activePatientJourneyModuleDetails?.working_enviroment}
                </div>
                <div>Habits</div>
                <div>{activePatientJourneyModuleDetails?.habits}</div>
                <div>DFI</div>
                <div>{activePatientJourneyModuleDetails?.dfi}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Additional Illnesses</div>
              <div className="details-table">
                <div>Idiopathic</div>
                <div>{activePatientJourneyModuleDetails?.idiopathic}</div>
                <div>Additional Illnesses</div>
                <div>
                  {activePatientJourneyModuleDetails?.additional_illnesses}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Other Details</div>
              <div className="details-table">
                <div>Inflammation</div>
                <div>
                  {activePatientJourneyModuleDetails?.additional_illnesses}
                </div>
                <div>Varicocele</div>
                <div>{activePatientJourneyModuleDetails?.varicocele}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">History of TESA</div>
              <div className="details-table">
                <div>History of TESA</div>
                <div>{activePatientJourneyModuleDetails?.history_of_tesa}</div>
                <div>Biopsy Result</div>
                <div>{activePatientJourneyModuleDetails?.biopsy_result}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Semen Analysis</div>
              <div className="details-table">
                <div>Date of semen analysis</div>
                <div>
                  {activePatientJourneyModuleDetails?.date_semen_analysis
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.date_semen_analysis
                      )
                    : ""}
                </div>
                <div>Count</div>
                <div>{activePatientJourneyModuleDetails?.count}</div>
                <div>Motility</div>
                <div>{activePatientJourneyModuleDetails?.motility}</div>
                <div>Normal morphology (%)</div>
                <div>{activePatientJourneyModuleDetails?.morphology}</div>
                <div>DFI (%)</div>
                <div>{activePatientJourneyModuleDetails?.dfi_percent}</div>
                <div>Interpretation</div>
                <div>{activePatientJourneyModuleDetails?.interpretation}</div>
                <div>Frozen sample available?</div>
                <div>{activePatientJourneyModuleDetails?.frozen}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MaleInfertilityInvestigationModal;
